import { render, staticRenderFns } from "./PresenceReportNotesContent.vue?vue&type=template&id=4a8da2ff"
import script from "./PresenceReportNotesContent.vue?vue&type=script&lang=js"
export * from "./PresenceReportNotesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports